/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import styled from 'styled-components';
import Drawer from '@mui/material/Drawer';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import StyledProps from '../../theme/AppThemeInterface';

const DRAWER_WIDTH = 184;

const StyledDrawer = styled(Drawer)`
  grid-area: drawer;
  z-index: 4;
  transition: width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  background-color: ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};

  &.appheader__drawer--closed {
    > div {
      width: ${({ theme }: StyledProps) => theme.appHeaderHeightLarge};
      border-right: 1px solid ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};
      overflow: hidden;
      background-color: ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};
    }
  }

  &.appheader__drawer--opened {
    width: ${DRAWER_WIDTH}px;
    background-color: ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};

    > div {
      width: ${DRAWER_WIDTH}px;
      border-right: ${({ theme }: StyledProps) => `1px solid ${theme.secondaryBackgroundColor}`};
      box-shadow: 2px 0px 5px ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};
    }
  }

  @media print {
    display: none;
  }
`;

export const StyledSwipeableDrawer = styled(SwipeableDrawer)`
  border-right: ${({ theme }: StyledProps) => `1px solid ${theme.primaryBackgroundColor}`};
  background-color: ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};

  &.appheader__drawer--opened {
    background-color: ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};

    width: ${DRAWER_WIDTH}px;
    > div {
      overflow-y: hidden;
    }
  }

  div[role='button'] {
    width: ${DRAWER_WIDTH}px;
    height: 100%;
  }
`;

export default StyledDrawer;
